import { Role, roleString } from '@/api/consts.ts'

export default {
  methods: { roleString },
  computed: {
    canChoiceRegion() {
      return this.isSuperuser || this.isEditor
    },
    $user() {
      return this.$store.state.auth.user
    },
    $roles() {
      return this.$user.roles || []
    },
    isSuperuser() {
      return this.$roles.includes(Role.Superuser)
    },
    isYasLDPREditor() {
      return this.$roles.includes(Role.YasLDPREditor) || this.isSuperuser || this.isEditor
    },
    isVstupiOperator() {
      return this.$roles.includes(Role.VstupiOperator) || this.isSuperuser
    },
    isEditor() {
      return this.$roles.includes(Role.Editor) || this.isSuperuser
    },
    isROSMM() {
      return this.$roles.includes(Role.ROSMM) || this.isSuperuser
    },
    isRO() {
      return (
        this.$roles.includes(Role.ROCoordinator) ||
        this.$roles.includes(Role.ROPress) ||
        this.isStaff ||
        this.isSuperuser
      )
    },
    isHPS() {
      return this.isSuperuser || this.$roles.includes(Role.HPSEditor)
    },
    isStaff() {
      return this.$roles.includes(Role.Staff) || this.isSuperuser
    },
    isEditorOrMore() {
      return this.isSuperuser || this.isEditor
    },
    isActivist() {
      return this.$roles.includes(Role.Activist) || this.isSuperuser
    },
    hasPublishPermission() {
      if (this.isEditor || this.isSuperuser) {
        return true
      }
      return this.$store.state.auth.user.info
        ? this.$store.state.auth.user.info.publish_permission
        : false
    },
    hasRegionContentScopeAccess() {
      return this.isSuperuser || this.isEditor || this.isRO
    },
    hasActivistScopeAccess() {
      return this.isSuperuser
    },
  },
}
